/**
 * Step guidance for buying a plan (#956):
 * "1 Choose a plan → 2 Add-ons (optional) → 3 Checkout".
 *
 * Presentational. The page says which steps are done and which is current;
 * each step is a button that takes the customer to that part of the page.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** A step number. */
export type PlanStep = 1 | 2 | 3;

/** One step as shown. */
export interface PlanStepView {
  step: PlanStep;
  label: string;
  optional: boolean;
}

/** The three steps, in order. */
export const PLAN_STEPS: readonly PlanStepView[] = [
  { step: 1, label: 'Choose a plan', optional: false },
  { step: 2, label: 'Add-ons', optional: true },
  { step: 3, label: 'Checkout', optional: false },
];

@Component({
  selector: 'app-plan-steps',
  templateUrl: './plan-steps.component.html',
  styleUrl: './plan-steps.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PlanStepsComponent {
  /** The step the customer is on. */
  @Input() current: PlanStep = 1;

  /** Steps already done. */
  @Input() done: readonly PlanStep[] = [];

  /** A step was chosen; the page scrolls to it. */
  @Output() readonly stepSelect = new EventEmitter<PlanStep>();

  readonly steps = PLAN_STEPS;

  /** True when the step is done. */
  isDone(step: PlanStep): boolean {
    return this.done.includes(step);
  }
}
